// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { CANCEL_ONBOARDING_ENDPOINT_CONFIGURATION } from './constants/cancel-drop-modal-footer.service.constants';

const cancelOnboardingProcessService = async (): Promise<[{ [key: string]: never }, Response]> =>
  apiUtils.post(CANCEL_ONBOARDING_ENDPOINT_CONFIGURATION);

export { cancelOnboardingProcessService };
